// @ts-nocheck
import Button from 'atoms/button/button';
import Sheet from 'atoms/sheet/sheet';
import SheetBody from 'atoms/sheet/sheetBody/sheetBody';
import * as dynamicGridSelectors from 'models/dynamicGrid/selector';
import Stack from 'molecules/stack/stack';
import StackItem from 'molecules/stackItem/stackItem';
import * as generateOrderSelectors from './selectors';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as constants from './constants';
import ThetaGridPaginated from 'templates/thetaGridPaginated';
import _ from 'lodash';
import { REQUESTS } from 'utils/services/thetaretail/requests';
import { Typography } from 'antd';
import { useColumnAliasName } from 'hooks/useColumnAliasName';
import { fetchBookmarksList } from 'models/bookmarks/sagaActions';

type TProps = {
	hideModal: React.MouseEventHandler;
	handleNextClick: React.MouseEventHandler;
	goBack: React.MouseEventHandler;
};
const { Text, Title } = Typography;

const SelectSKUs = (props: TProps) => {
	const { hideModal, handleNextClick, goBack, hasReserveInventory } = props;
	const dispatch = useDispatch();
	const data = useSelector((state) => generateOrderSelectors.getData(state));
	const getColumnAliasName = useColumnAliasName(constants.UPLOAD_MODEL_ID);
	const tableId = data.isKitOrder ? constants.MODAL_TABLE_IDS.KIT_SKUS : constants.MODAL_TABLE_IDS.SKUS;

	const selectedSKUs = useSelector((state) =>
		dynamicGridSelectors.getTableSelection(
			state,
			data.isKitOrder ? constants.MODAL_TABLE_IDS.KIT_SKUS : constants.MODAL_TABLE_IDS.SKUS
		)
	);
	const isLoadingGrid = useSelector((state) =>
		dynamicGridSelectors.isLoading(
			state,
			data.isKitOrder ? constants.MODAL_TABLE_IDS.KIT_SKUS : constants.MODAL_TABLE_IDS.SKUS
		)
	);
	const hasGridData = useSelector(
		(state) =>
			dynamicGridSelectors.getGridData(
				state,
				data.isKitOrder ? constants.MODAL_TABLE_IDS.KIT_SKUS : constants.MODAL_TABLE_IDS.SKUS
			)?.length
	);
	const selectedStores = useSelector((state) =>
		dynamicGridSelectors.getTableSelection(state, constants.MODAL_TABLE_IDS.STORES)
	);

	const storeSearch = useSelector((state) =>
		dynamicGridSelectors.getGridFilters(state, constants.MODAL_TABLE_IDS.STORES)
	);

	React.useEffect(() => {
		dispatch(fetchBookmarksList({ tableId }));
	}, [dispatch, tableId]);

	const [ref, handleUpdateRef] = useState(null);

	const validateFormData = React.useCallback(() => {
		let hasError = true;

		if (selectedSKUs && ((selectedSKUs.isSelectAll && hasGridData) || selectedSKUs?.selectedRowKeys?.length)) {
			hasError = false;
		}

		return hasError;
	}, [selectedSKUs]);

	const gridConfig = {
		enableSelection: true,
		enableSorting: true,
		selectionCallBack: () => {},
	};
	const customerOptions = useSelector((state) => generateOrderSelectors.getCustomerOptions(state));
	const templateConfig = {
		gridConfig,
		isFilterEnabled: true,
		tableId,

		dataProviderOptions: {
			version: 2,
			type: 'POST',
			queryParams: {},
			...REQUESTS.POST.GET_GRID_DETAILS_V2,
			pathParams: {
				tableId,
			},
			multiSelectFieldGroups: {
				CustomerID: data.customerID.includes('-1')
					? customerOptions.map(({ value }) => value).join(',')
					: data.customerID,
				StoreList: selectedStores.isSelectAll ? 'ALL' : selectedStores?.selectedRowKeys.join(','),
				WarehouseID: data.warehouseID,
				ShippingMethodID: data.shipMethodID,
				StoreScheduleID: data.useStoreSchedule ? data.storeScheduleID : undefined,
				IsKitOrder: data.isKitOrder,
				StartShipDate: data.shipStartDate,
				UsePrimaryWarehouse: data.isPrimaryWarehouse,
				UsePlanogram: data.usePlanogram,
				EndShipDate: data.shipToDate,
			},
			multiSelectFilterFieldGroups: {
				StoreSearch: selectedStores?.isSelectAll ? (storeSearch?.search ?? []) : [],
			},
			body: {
				fieldGroups: {
					CustomerID: data.customerID.includes('-1')
						? customerOptions.map(({ value }) => value).join(',')
						: data.customerID,
					StoreList: selectedStores.isSelectAll ? 'ALL' : selectedStores?.selectedRowKeys.join(','),
					WarehouseID: data.warehouseID,
					ShippingMethodID: data.shipMethodID,
					StoreScheduleID: data.useStoreSchedule ? data.storeScheduleID : undefined,
					IsKitOrder: data.isKitOrder,
					StartShipDate: data.shipStartDate,
					UsePrimaryWarehouse: data.isPrimaryWarehouse,
					UsePlanogram: data.usePlanogram,
					EndShipDate: data.shipToDate,
				},
				filterGroups: {
					StoreSearch: selectedStores?.isSelectAll ? (storeSearch?.search ?? []) : [],
				},
			},
		},
		selectRowKey: 'SKUID',
	};
	return (
		<Sheet isPage className="order-tbl p-0">
			<SheetBody isTransparent className="p-0">
				<Stack isVertical gutter="small" className="generte-order-wrapper">
					<Stack className="generte-order-head p-0">
						<Title level={4}>{getColumnAliasName('Select SKUs')}</Title>
					</Stack>
					<StackItem onDomRef={handleUpdateRef} isStretch isGrow>
						{/* <Sheet isPage>
          <SheetBody> */}
						<ThetaGridPaginated isStorageEnabled={false} offset={60} parent={ref} config={templateConfig} />
						{/* </SheetBody>
        </Sheet> */}
					</StackItem>
					<StackItem>
						<Stack align="left" gutter="small">
							<StackItem isGrow>
								<Button isText name="Reselect Stores" handleClick={goBack} />
							</StackItem>

							<StackItem isStretch align="right">
								<Button
									isPrimary
									disabled={(isLoadingGrid && !hasGridData) || validateFormData()}
									name={data.useReserveInventory ? 'Select Reserve Inventory' : 'Review Orders'}
									handleClick={handleNextClick}
								/>
							</StackItem>
						</Stack>
					</StackItem>
				</Stack>
			</SheetBody>
		</Sheet>
	);
};

export default SelectSKUs;
